/* Nächste Verkaufsstelle per PLZ, Luftlinie, Umkreis 100 km (blocks/ei-vor-ort.liquid). Die Daten laden erst beim ersten Suchen. */
(function () {
  var UMKREIS_KM = 100;
  var daten = null;

  function km(a, b, c, d) {
    var r = Math.PI / 180, x = Math.sin(((c - a) * r) / 2), y = Math.sin(((d - b) * r) / 2);
    return 12742 * Math.asin(Math.sqrt(x * x + Math.cos(a * r) * Math.cos(c * r) * y * y));
  }

  function absatz(ziel, text, klasse) {
    var p = document.createElement('p');
    p.textContent = text;
    if (klasse) p.className = klasse;
    ziel.appendChild(p);
    return p;
  }

  function zeige(box, plz) {
    var ziel = box.querySelector('[data-ergebnis]');
    ziel.textContent = '';
    if (!/^\d{5}$/.test(plz)) return absatz(ziel, 'Bitte gib eine fünfstellige Postleitzahl ein.');
    var punkt = daten.plz[plz];
    if (!punkt) return absatz(ziel, 'Diese Postleitzahl kennen wir leider nicht. Bitte prüfe sie noch einmal.');
    var beste = null, abstand = Infinity;
    daten.orte.forEach(function (o) {
      var e = km(punkt[0], punkt[1], o.lat, o.lng);
      if (e < abstand) { abstand = e; beste = o; }
    });
    if (abstand > UMKREIS_KM) {
      return absatz(ziel, 'Im Umkreis von 100 km gibt es noch keine Verkaufsstelle. Bestell deinen Honig einfach hier online, wir schicken ihn dir nach Hause.');
    }
    absatz(ziel, 'Hier gibt es ElbeImker-Honig in deiner Nähe:');
    absatz(ziel, beste.n, 'ei-vor-ort__name');
    absatz(ziel, beste.a);
    absatz(ziel, 'ca. ' + Math.max(1, Math.round(abstand)) + ' km Luftlinie' + (beste.h ? ' · ' + beste.h : ''));
    var p = document.createElement('p');
    var a = document.createElement('a');
    a.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(beste.n + ', ' + beste.a);
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'In Google Maps öffnen';
    p.appendChild(a);
    ziel.appendChild(p);
  }

  function start(box) {
    var feld = box.querySelector('input[name="plz"]');
    feld.addEventListener('input', function () { feld.value = feld.value.replace(/\D/g, ''); });
    box.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var plz = feld.value.trim();
      if (daten) return zeige(box, plz);
      fetch(box.dataset.url)
        .then(function (r) { return r.json(); })
        .then(function (d) { daten = d; zeige(box, plz); })
        .catch(function () {
          var ziel = box.querySelector('[data-ergebnis]');
          ziel.textContent = '';
          absatz(ziel, 'Das hat gerade nicht geklappt. Alle Standorte findest du unten verlinkt.');
        });
    });
  }

  function los() { document.querySelectorAll('[data-ei-vor-ort]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
